import styled, { css } from 'styled-components';

import { basicBodyTextStyle, basicCaptionSmallTextStyle } from '@dreryk/react-components';

export const StyledContent = styled.div<{ $disabled: boolean | undefined }>`
   ${basicBodyTextStyle};
   ${(props) =>
      props.$disabled &&
      css`
         color: ${props.theme.placeholder};
      `}
`;

StyledContent.displayName = 'StyledContent';

export const StyledDescription = styled.div`
   ${basicCaptionSmallTextStyle};
`;

StyledDescription.displayName = 'StyledDescription';
